module.exports = __webpack_public_path__ + "img/desktop-hit-a-wall.abc1768d.png";